import { render, staticRenderFns } from "./ArchiveJobButton.vue?vue&type=template&id=5a7c8268"
import script from "./ArchiveJobButton.vue?vue&type=script&lang=js"
export * from "./ArchiveJobButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports